import $ from 'jquery'
/**
 * @module
 * @api
 */

import Config from './api/Config'
import Geometry from './api/Geometry'
import Layer from './api/Layer'
import Select from './api/Select'
import Ui from './api/Ui'
import Zoom from './api/Zoom'
import Draw from './api/Draw'
import AutoSearch from './api/AutoSearch'
import Toolbar from './api/Toolbar'
import Identify from './api/Identify'
import Applications from './api/Applications'

import { getSelectStyleFunction } from './ol'

/**
 * Api class
 * @param {Object} config
 * @param {boolean=} config.enableToggle True to enable pressed/not
 *     pressed toggling. Defaults to false.
 * @constructor
 * @api
 */
export default function Api(config) {
  $.extend(this, config || {})
  /**
   * @type {module:api/Layer}
   * @memberof! module:Api#
   * @api
   */
  this.layer = new Layer(config)

  /**
   * @member {module:api/Geometry}
   * @memberof! module:Api#
   * @api
   */
  this.geometry = new Geometry({
    map: this.map,
    layer: this.layer
  })

  /**
   * @type {module:api/Select}
   * @memberof! module:Api#
   * @api
   */
  this.select = new Select({
    map: this.map,
    geometry: this.geometry,
    style: getSelectStyleFunction()
  })

  /**
   * @type {module:api/Zoom}
   * @memberof! module:Api#
   * @api
   */
  this.zoom = new Zoom({
    map: this.map,
    geometry: this.geometry,
    layer: this.layer
  })

  /**
   * @type {module:api/Ui}
   * @memberof! module:Api#
   * @api
   */
  this.ui = new Ui({})

  this.toolbar = new Toolbar({ client: this.client })

  /**
   * @type {module:api/AutoSearch}
   * @memberof! module:Api#
   * @api
   */
  this.autoSearch = new AutoSearch({})

  /**
   * @type {module:api/Draw}
   * @memberof! module:Api#
   * @api
   */
  this.draw = new Draw({
    map: this.map,
    geometry: this.geometry
  })

  /**
   * @type {module:api/Config}
   * @memberof! module:Api#
   * @api
   */
  this.config = new Config({
    map: this.map
  })

  /**
   * @type {module:api/Identify}
   * @memberof! module:Api#
   * @api
   */
  this.identify = new Identify({})


  /**
   * @type {module:api/Applications}
   * @memberof! module:Api#
   * @api
   */
  this.applications = new Applications(this.applications)
}
